export const de = {
  'Homepage': 'Startseite',
  'Main Dashboard': 'Haupt-Dashboard',
  'Inventory Dashboard': 'Inventar-Dashboard',
  'Chat': 'Chat',
  'Shelf Planner': 'Tablarplaner',
  'Reports': 'Berichte',
  'Catalog': 'Katalog',
  'Stored Items': 'Eingelagerte Artikel',
  'Replenishments': 'Aufstockungen',
  'Expired': 'Abgelaufen',
  'Transfers': 'Transfers',
  'In Progress': 'In Bearbeitung',
  'Cancelled': 'Abgebrochen',
  'Suspended': 'Ausgesetzt',
  'Customers': 'Kunden',
  'Goods In': 'Wareneingang',
  'All': 'Alle',
  'PTL Rack': 'PTL-Regal',
  'Cross-Docking': 'Cross-Docking',
  'Resources': 'Ressourcen',
  'Shelf Maps': 'Tablarlayouts',
  'Warehouses & Zones': 'Hallen & Zonen',
  'Import/Export': 'Import/Export',
  'Units of Measure': 'Maßeinheiten',
  'Smart Tags': 'Smart Tags',

  'Login': 'Login - WMS360',
  'Please enter your credentials to sign in!': 'Bitte geben Sie Ihre Anmeldedaten ein, um sich anzumelden!',
  'Email': 'E-Mail',
  'Password': 'Passwort',
  'Remember Me': 'Angemeldet bleiben',
  'Forgot Password?': 'Passwort vergessen?',
  'Signing in...': 'Anmeldung läuft...',
  'Sign In': 'Anmelden',
  'Incorrect email or password': 'E-Mail oder Passwort falsch',

  'Forgot Password': 'Passwort vergessen',
  'Check your email': 'Überprüfen Sie Ihre E-Mails',
  'We have sent a password recovery instruction to your email': 'Wir haben Anweisungen zur Passwortwiederherstellung an Ihre E-Mail gesendet',
  'Please enter your email address to receive a verification code': 'Bitte geben Sie Ihre E-Mail-Adresse ein, um einen Bestätigungscode zu erhalten',
  'Resend Email': 'E-Mail erneut senden',
  'Send Email': 'E-Mail senden',
  'Back to': 'Zurück zu',
  'Sign in': 'Anmelden',
  'Reset done': 'Zurücksetzen abgeschlossen',
  'Your password has been successfully reset': 'Ihr Passwort wurde erfolgreich zurückgesetzt',
  'Set new password': 'Neues Passwort festlegen',
  'Your new password must different to previous password': 'Ihr neues Passwort muss sich vom vorherigen unterscheiden',
  'Confirm Password': 'Passwort bestätigen',

  'Submitting ...': 'Übermitteln ...',
  'Submit': 'Absenden',
  'Continue': 'Fortfahren',

  'Inventory': 'Inventar',
  'Dashboard': 'Dashboard',
  'Filter': 'Filter',
  'Pick Confirmed': 'Auswahl bestätigt',
  'Sold': 'Verkauft',
  'Short Items': 'Fehlende Artikel',
  'Fix': 'Beheben',
  'Status': 'Status',
  'Paid': 'Bezahlt',
  'Pending': 'Ausstehend',
  'Failed': 'Fehlgeschlagen',
  'Date': 'Datum',
  'Amount': 'Menge',
  'Snapshot Variance Reports': 'Berichte zur Snapshot-Abweichung',
  'Unique Items': 'Einzigartige Artikel',
  'Total Item Count': 'Gesamtanzahl der Artikel',
  'Stock Count': 'Inventur',
  'Inbound Items': 'Eingehende Artikel',

  'Available': 'Verfügbar',
  'Low Stock': 'Niedriger Bestand',
  'Out of Stock': 'Nicht auf Lager',
  'Total Stock': 'Gesamtbestand',

  'Value Distribution': 'Wertverteilung',
  'Vertical': 'Lifte',
  'Racking': 'Regale',
  'Quarantine': 'Quarantäne',
  'Inspection': 'Inspektion',

  'Variance Value': 'Abweichungswert',
  'Warehouse Capacity': 'Lagerkapazität',

  'Activities': 'Aktivitäten',
  'View All': 'Alle anzeigen',
  'No Activities': 'Keine Aktivitäten',

  'Batch Cycles': 'Batch-Zyklen',
  'Performance': 'Performance',
  'Staff': 'Mitarbeiter',

  'Pending Jobs': 'Anstehende Jobs',
  'Completed Jobs': 'Abgeschlossene Jobs',
  'Put away': 'Eingelagert am',
  'Picks Completed': 'Auswahlen abgeschlossen',
  'Active Staff': 'Aktive Mitarbeiter',
  'Work Load': 'Arbeitsbelastung',

  'Fulfilment Time (avg)': 'Durchführungszeit (Ø)',
  'Order': 'Bestellung',
  'Total': 'Gesamt',
  'Latest Orders': 'Neueste Bestellungen',
  'View Orders': 'Bestellungen anzeigen',

  'Categories': 'Kategorien',

  'Orders Dashboard': 'Bestellübersicht',
  'View your current sales & summary': 'Zeigen Sie eine Übersicht der aktuellen Verkäufe an',
  'Sales Report': 'Sales Report',
  'Export Report': 'Report exportieren',

  'Revenue': 'Umsatz',
  'Orders': 'Bestellungen',
  'Purchases': 'Einkäufe',

  'Processing': 'In Bearbeitung',
  'Return': 'Rückgabe',
  'Units': 'Einheiten',
  'Scan Confirmed': 'Scan bestätigt',

  'Top Selling': 'Meistverkauft',
  'View Products': 'Produkte anzeigen',
  'Article': 'Artikel',
  'Title': 'Titel',
  'Quantity': 'Menge',
  'Expired Date': 'Ablaufdatum',

  'Product': 'Produkt',
  'Products': 'Produkte',
  'Warehouse': 'Halle',
  'Zone': 'Zone',
  'Lift': 'Lift',
  'Lifts': 'Lifte',
  'Lift Type': 'Lift-Typ',
  'Lift Types': 'Lift-Typen',
  'Lift Number': 'Lift-Nummer',
  'Lift Name': 'Locker Name',
  'Shelf': 'Tablar',
  'Shelves': 'Tablare',
  'User': 'Benutzer',
  'Users': 'Benutzer',
  'User name': 'Benutzername',
  'Username': 'Benutzername',
  'Access point': 'Entnahme',
  'Barcode': 'Barcode',
  'Width': 'Breite',
  'Height': 'Höhe',
  'Depth': 'Tiefe',
  'Depths': 'Tiefen',
  'Compartment': 'Fach',
  'Compartments': 'Fächer',
  'Type': 'Typ',
  'S/C/D': 'Tablar/Fach/Tiefe',
  'Created': 'Erstellt',
  'Color': 'Farbe',
  'Count': 'Zählen',
  'Counts': 'Zählungen',
  'Max': 'Max',
  'Put': 'Eingelagert am',
  'Pick': 'Pick',
  'Location': 'Standort',
  'Locations': 'Standorte',
  'Description': 'Beschreibung',
  'Pick Sheet': 'Pick Sheet',
  'Movements': 'Bewegungen',
  'Movement': 'Bewegung',
  'Job Name': 'Job-Name',
  'Required Quantity': 'Erforderliche Menge',
  'Actual Quantity': 'Tatsächliche Menge',
  'Other': 'Andere',
  'Bin': 'Behälter',
  'Bins': 'Behälter',
  'Setting': 'Einstellung',
  'Settings': 'Einstellungen',
  'Max Qty.': 'Max. Menge',

  'Filter by dates range': 'Nach Datumsbereich filtern',
  'Min Qty.': 'Min. Menge',
  'Current Stock': 'Aktueller Bestand',
  'Transfer': 'Transfer',
  'Add Product': 'Produkt hinzufügen',

  'No product found!': 'Kein Produkt gefunden!',
  'Add': 'Hinzufügen',
  'Cancel': 'Abbrechen',
  'Save': 'Speichern',
  'Edit': 'Bearbeiten',
  'Delete': 'Löschen',
  'Discard': 'Verwerfen',

  'Track #': 'Sendungsnummer',
  'Order Date': 'Bestelldatum',
  'Shipping Method': 'Versandart',
  'Supplier': 'Lieferant',

  'Related Products': 'Zugehörige Produkte',
  'Consignment': 'Sendung',
  'Consigned': 'Versandt',
  'Owner': 'Eigentümer',
  'Search Owner': 'Eigentümer suchen',

  'Scan to pick': 'Zum Entnehmen scannen',
  'Active': 'Aktiv',
  'Block': 'Blockieren',
  'Pick Method': 'Entnahmemethode',
  'FIFO': 'FIFO',
  'Optimised': 'Optimiert',
  'Security': 'Sicherheit',
  'Stock Take': 'Inventur',
  'Stock Valuation': 'Bestandsbewertung',

  'Unit Of Measure': 'Maßeinheit',
  'Print Label on Pick': 'Etikett beim Entnehmen drucken',
  'Is Serialised': 'Seriennummern geführt',

  'Receiving': 'Wareneingang',

  'This field is required': 'Dieses Feld ist erforderlich',
  'Enter correct url!': 'Bitte eine korrekte URL eingeben!',
  'Something wrong! Can not upload file': 'Etwas ist schiefgelaufen! Datei-Upload nicht möglich',
  'Max quantity of the bins are required': 'Maximalmenge für Behälter ist erforderlich',
  'Product successfully added': 'Produkt erfolgreich hinzugefügt',
  'article is existed.': 'Artikel ist bereits vorhanden.',
  'Error !!!': 'Fehler !!!',
  'Min Quantity': 'Mindestmenge',
  'UOM': 'ME (Maßeinheit)',
  'Fifo': 'FiFo',
  'Pick multiplier': 'Pick-Multiplikator',
  'Put away multiplier': 'Einlagerungs-Multiplikator',
  'Buy Price': 'Einkaufspreis',
  'Sell Price': 'Verkaufspreis',
  'ERP Code': 'ERP-Code',
  'Manufacturer': 'Hersteller',
  'Model': 'Modell',
  'Make': 'Marke',
  'Is serial numbered': 'Seriennummer geführt',
  'H1': 'H1',
  'H2': 'H2',
  'H3': 'H3',
  'H4': 'H4',
  'H5': 'H5',
  'H6': 'H6',
  'Auto print label': 'Etikett automatisch drucken',
  'Scan pick': 'Pick-Vorgang scannen',
  'Product Image': 'Produktbild',
  'Please upload a image file!': 'Bitte laden Sie eine Bilddatei hoch!',
  'Upload image cannot more then {{size}}kb !': 'Das Bild darf nicht größer als {{size}}kb sein!',
  'Add or change image for the product': 'Fügen Sie ein Produktbild hinzu oder ändern Sie es',
  'Drop your image here, or': 'Ziehen Sie Ihr Bild hierher oder',
  'browse': 'durchsuchen',
  'Support: image files': 'Unterstützt: Bilddateien',
  'Use Webcam': 'Webcam verwenden',
  'Capture photo': 'Foto aufnehmen',
  'Are you sure you want to delete this product? All record related to this product will be deleted as well. This action cannot be undone.': 'Sind Sie sicher, dass Sie dieses Produkt löschen möchten? Alle zugehörigen Aufzeichnungen werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  'Delete product': 'Produkt löschen',

  'Counted': 'Gezählt',
  'Completed': 'Abgeschlossen',

  'Category': 'Kategorie',
  'Created At': 'Erstellt am',
  'Started At': 'Begonnen am',
  'Completed At': 'Abgeschlossen am',
  'Item count': 'Artikelanzahl',
  'Value': 'Wert',
  'Recounted': 'Neu gezählt',
  'Variance': 'Abweichung',
  'Approved': 'Genehmigt',

  'Checked': 'Geprüft',
  'Checked By': 'Geprüft von',
  'Checked Date': 'Prüfdatum',
  'Comment': 'Kommentar',
  'Sending ...': 'Senden ...',
  'Send': 'Senden',
  'Recount All': 'Alle neu zählen',
  'Approval All': 'Alle genehmigen',
  'Matching': 'Übereinstimmend',
  'Recount': 'Neu zählen',

  'Count Name': 'Zählungs-Name',
  'Cycle Count': 'Zyklus-Inventur',
  'Select the stock take group to count.': 'Wählen Sie die zu zählende Inventurgruppe aus.',
  'In which warehouse': 'In welcher Halle',
  'Should the articles being counted now be made inactive so they they can not be picked or put until after they have been counted ?': 'Sollen die derzeitigen Inventur-Artikel inaktiv gesetzt werden, damit sie nicht entnommen oder eingelagert werden können, bis die Inventur abgeschlossen ist?',
  'Cycle A': 'Zyklus A',
  'Cycle B': 'Zyklus B',
  'Cycle C': 'Zyklus C',
  'No Count': 'Keine Zählung',

  'All Locations': 'Alle Standorte',
  'Shelf Size': 'Tablargröße',
  'Lift/Rack Name': 'Lift/Regalname',

  'Bulk': 'Bulk',
  'Cross Docking': 'Cross-Docking',
  'Inspections': 'Inspektionen',
  'Locker': 'Locker',
  'Lockers': 'Locker',
  'Are you sure you want to delete this lift? All record related to this lift will be deleted as well. This action cannot be undone.': 'Sind Sie sicher, dass Sie diesen Lift löschen möchten? Alle zugehörigen Daten werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  'Delete lift': 'Aufzug löschen',
  'Add Location': 'Standort hinzufügen',
  'Location successfully added': 'Standort erfolgreich hinzugefügt',
  'The location is existed': 'Der Standort ist bereits vorhanden',
  'Rack Number': 'Regal-Nummer',
  'Rack Name': 'Regal-Name',
  'Rack Description': 'Regal-Beschreibung',
  'Shelves (S)': 'Regalebene (E)',
  'Compartments (C)': 'Fächer (F)',
  '\'Depths (D)': 'Tiefen (T)',
  'Shelf Width (mm)': 'Regal-Breite (mm)',
  'Shelf Depth (mm)': 'Regal-Tiefe (mm)',
  'No lift found!': 'Kein Lift gefunden!',
  'Required': 'Erforderlich',

  'Speed': 'Geschwindigkeit',
  'Security Groups': 'Sicherheits-Gruppen',
  'Notes': 'Notizen',

  'Assign a Shelf map': 'Ein Tablarlayout zuweisen',
  'I understand': 'Ich verstehe',
  'Select the shelf map to assign.': 'Wählen Sie das zuzuweisende Tablarlayout aus.',
  'Actions': 'Aktionen',
  'Shelf Map': 'Tablarlayout',

  'Add Vertical': 'Lift hinzufügen',
  'Edit Vertical': 'Lift bearbeiten',
  'Please Select': 'Bitte auswählen',
  'Lift Group': 'Lift-Gruppe',
  'Lock Timer (seconds)': 'Logout-Timer (sekunden)',
  'Number Of Shelves': 'Tablar-Anzahl',
  'Shelf Width': 'Tablar-Breite',
  'Shelf Depth': 'Tablar-Tiefe',
  'Serial Number': 'Seriennummer',
  'License Key': 'Lizenzschlüssel',
  'Login Required': 'Anmeldung erforderlich',
  'Manage Articles': 'Artikel verwalten',
  'Auto Generated Article Codes': 'Automatisch generierte Artikelnummer',
  'Use Security': 'Sicherheit verwenden',
  'Vertical successfully added. Restart the mpx VLM Services to activate the new lift': 'Lift erfolgreich hinzugefügt. Starten Sie die MPX-VLM-Dienste neu, um den neuen Lift zu aktivieren',
  'Generic Error': 'Allgemeiner Fehler',
  'Access Point': 'Entnahme',
  'Language': 'Sprache',
  'Controller PC IP address': 'Bediener-PC IP-Adresse',
  'Label Printer': 'Labeldrucker',
  'Printer': 'Drucker',
  'Article Label Format': 'Labelformat für Artikel',
  'Question 1': 'Frage 1',
  'Question 2': 'Frage 2',
  'Allow Picking': 'Pick erlauben',
  'Allow Putting': 'Einlagerung erlauben',
  'Allow Searching': 'Suche erlauben',
  'Allow Get Shelf': 'Tablar anfordern erlauben',
  'Reverse Shelf Map': 'Tablarlayout spielgeln',
  'Store After Pick': 'Nach Entnahme einlagern',
  'Store After Job': 'Nach Job einlagern',
  'Manage Lift': 'Lifte verwalten',
  'Manage Racking': 'Regale verwalten',
  'Manage Lockers': 'Schließfächer verwalten',
  'Enable Camera': 'Kamera aktivieren',
  'Left Camera': 'Linke Kamera',
  'Right Camera': 'Rechte Kamera',
  'Images storage': 'Bild-Speicherort',
  'Select images storage': 'Bild-Speicherort auswählen',
  'Local Storage': 'Lokaler Speicher',
  'AWS S3': 'AWS S3',
  'Local Path': 'Lokaler Pfad',
  'AWS Bucket Name': 'AWS-Bucket-Name',
  'AWS Dir Name': 'AWS-Verzeichnisname',
  'AWS Region': 'AWS-Region',
  'AWS Access Key Id': 'AWS Access Key ID',
  'AWS Secret Access Key': 'AWS Secret Access Key',
  // TODO : orders, pages, resources, shared, components (table, pagination, ...)

  'Put Away': 'Eingelagert am',
  'Put Away Value': 'Einlagerungswert',
  'Returns': 'Rücksendungen',
  'units': 'Einheiten',
  'days': 'Tage',
  'Oldest Pending Job': 'Ältester ausstehender Auftrag',
  'Average Orders Per Months': 'Durchschnittliche Bestellungen pro Monat',
  'Average Pending Time': 'Durchschnittliche Wartezeit',
  'Picks': 'Entnahmen',
  'Latest Order': 'Neueste Bestellung',
  'Oldest Pending': 'Älteste ausstehende',
  'Created Date': 'Erstellungsdatum',
  'Customer': 'Kunde',

  'Any question?': 'Irgendwelche Fragen?',
  'Message ...': 'Nachricht ...',
  'Sorry I don\'t understand your question': 'Entschuldigung, ich verstehe Ihre Frage nicht',
  'Order History': 'Bestellverlauf',
  'Download Template': 'Vorlage herunterladen',
  'Article Information': 'Artikelinformationen',
  'Drop your file here, or': 'Ziehen Sie Ihre Datei hierher oder',
  'Support': 'Unterstützung',
  'Refresh': 'Aktualisieren',
  'Export': 'Export',
  'Search': 'Suchen',
  'Total {{number}} Items': 'Gesamtzahl {{number}} Artikel',
  'page': 'Seite',

  'Copyright': 'Urheberrecht',
  'Term & Conditions': 'Allgemeine Geschäftsbedingungen',
  'Privacy & Policy': 'Datenschutz und Richtlinien',
  'Profile': 'Profil',
  'Sign Out': 'Abmelden',

  // update 1/3/2025
  'Priority': 'Priorität',
  'Completed Orders': 'Abgeschlossene Bestellungen',
  'Jobs': 'Aufgaben',
  'Items': 'Artikel',

  'Name': 'Name',
  'Birthday': 'Geburtstag',
  'orders': 'bestellungen',
  '(mins)': '(mins)',
  'per session': 'pro session',
  'Last Order': 'Letzte Bestellung',
  'Total Customers': 'Gesamtanzahl Kunden',
  'Active Customers': 'Aktive Kunden',
  'New Customers': 'Neue Kunden',

  'Batch Code': 'Batch Code',
  'Purchase Order': 'Bestellnummer',
  'Supplier Name': 'Lieferant',
  'Receipted': 'Empfangsdatum',
  'Progress': 'Fortschritt',
  'Bay': 'Bay',
  'Next Batch': 'Nächster Batch',
  'Pending Orders': 'Ausstehende Bestellungen',
  'No data': 'Keine Daten',
  'Delivery Address': 'Lieferadresse',
  'Date Created': 'Erstellungsdatum',
  'Date Required': 'Anforderungsdatum',
  'Date Started': 'Startdatum',
  'Date Processed/Completed': 'Bearbeitungsdatum/Abgeschlossen',
  'Processing Time': 'Bearbeitungszeit',
  'Picked': 'Entnommen',
  'Picker': 'Entnehmer',
  'Qty': 'Anzahl',
  'View Carrier Details': 'Carrier Details anzeigen',
  'No order found!': 'Keine Bestellung gefunden!',
  'Rack Picks': 'Regalentnahme',
  'Delete order': 'Bestellung löschen',
  'Are you sure you want to delete this order? All record related to this order will be deleted as well. This action cannot be undone.': 'Sind Sie sicher, dass Sie diese Bestellung löschen wollen? Alle zugehörigen Daten werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  'Access Denied!': 'Zugriff verweigert!',
  'You have no permission to visit this page': 'Sie haben keine Berechtigung, diese Seite zu besuchen',

  'Red': 'Rot',
  'Green': 'Gruen',
  'Blue': 'Blau',
  'Yellow': 'Gelb',
  'Width (mm)': 'Breite (mm)',
  'Depth (mm)': 'Tiefe (mm)',
  'Height (mm)': 'Hoehe (mm)',
  'Weight (kg)': 'Gewicht (kg)',
  'Volume (m3)': 'Volumen (m3)',
  'Material': 'Material',
  'Single Checkbox': 'Einzelne Checkbox',
  'I agree to the terms and conditions': 'Ich stimme den Bedingungen zu',
  'Clone as rotated bin': 'Klonen als rotiertes Regal',
  'Bin successfully added': 'Regal erfolgreich hinzugefügt',
  'Edit Bin': 'Regal bearbeiten',
  'Create New Bin': 'Neues Regal erstellen',
  'Delete bin': 'Regal löschen',
  'Are you sure you want to delete this bin? All record related to this bin will be deleted as well. This action cannot be undone.': 'Sind Sie sicher, dass Sie dieses Regal löschen wollen? Alle zugehörigen Daten werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  'Devices': 'Geraete',
  'Options': 'Optionen',
  'Download': 'Herunterladen',
  'Upload': 'Hochladen',
  'Description of': 'Beschreibung von',
  'List of files': 'Liste der Dateien',
  'Stock On Hand': 'Lagerbestand',
  'Upload file cannot more then {{size}} kb!': 'Die Datei darf nicht mehr als {{size}} kb sein!',
  'Upload successful': 'Hochladen erfolgreich',
  'Articles': 'Artikel',
  'Images': 'Bilder',
  'Upload a png or jpg file with the file name the same as the article id.': 'Laden Sie eine png oder jpg-Datei hoch, die den Dateinamen mit der Artikel-ID identisch ist.',
  'Delete Security Group': 'Sicherheitsgruppe löschen',
  'Are you sure you want to delete this security group?': 'Sind Sie sicher, dass Sie diese Sicherheitsgruppe löschen wollen?',
  'Group Name': 'Gruppenname',
  'Group Description': 'Gruppenbeschreibung',
  'Security Group has been submitted successfully': 'Sicherheitsgruppe wurde erfolgreich eingereicht',
  'Edit {{name}} Group': 'Bearbeiten {{name}} Gruppe',
  'Add {{name}} Group': 'Hinzufügen {{name}} Group',
  'Assign Users': 'Benutzer zuweisen',
  'Bin Information': 'Regalinformationen',
  'Multiple Product Bin': 'Mehrfachproduktregal',
  'ESL Tag': 'ESL Tag',
  'Location Name': 'Standortname',
  'Y position': 'Y Position',
  'X position': 'X Position',
  'Delete {{name}}': 'Löschen {{name}}',
  'Are you sure you want to delete this {{name}}?': 'Sind Sie sicher, dass Sie dieses {{name}} löschen wollen?',
  'Edit {{name}}': 'Bearbeiten {{name}}',
  'Add {{name}}': 'Hinzufügen {{name}}',
  'Search Production': 'Produktion suchen',
  'No result': 'Kein Ergebnis',
  'Add bin to the map': 'Regal zum Regalplan hinzufügen',
  'Add bins to the map': 'Regale zum Regalplan hinzufügen',
  'Successfully': 'Erfolgreich',
  'The changes you have made, are not saved.': 'Die gegebenen Aktionen wurden nicht gespeichert.',
  'Do you wish to exit without saving ?': 'Wollen Sie ohne Speichern verlassen?',
  'No': 'Nein',
  'Yes': 'Ja',
  'No shelf map found!': 'Kein Regalplan gefunden!',
  'The changes you have made, are not saved. Do you wish to exit without saving ?': 'Die gegebenen Aktionen wurden nicht gespeichert. Wollen Sie ohne Speichern verlassen?',
  'Date Put': 'Datum Einlagern',
  'Serial Numbers': 'Seriennummern',
  'Serial': 'Seriennummer',
  'Are you sure you want to delete this serial number?': 'Sind Sie sicher, dass Sie diese Seriennummer löschen wollen?',
  'Delete serial number': 'Seriennummer löschen',
  'Add serial number': 'Seriennummer hinzufügen',
  'There is no enough space to add this bin': 'Es ist kein Platz mehr, um dieses Regal hinzuzufügen',
  'There is no enough space to add this bin at selected position': 'Es ist kein Platz mehr, um dieses Regal hinzuzufügen',
  'Do you want to clean map?': 'Wollen Sie den Regalplan löschen?',
  'This box can not be deleted.': 'Dieses Regal kann nicht gelöscht werden.',
  'Assign Article': 'Artikel zuweisen',
  'Delete Selected Box': 'Ausgewhltes Regal löschen',
  'Clear Map': 'Regalplan löschen',
  'Zoom Out': 'Zoom Aus',
  'Zoom In': 'Zoom Ein',
  'Zoom': 'Zoom',
  'Delete selected': 'Ausgewhltes löschen',
  'Exit fullscreen': 'Fullscreen verlassen',
  'Fullscreen': 'Fullscreen',
  'Successfully added': 'Erfolgreich hinzugefügt',
  'Must be a number': 'Muss eine Zahl sein',
  'Edit shelf map': 'Regalplan bearbeiten',
  'Add new shelf map': 'Neuen Regalplan hinzufügen',
  'Map name': 'Regalplanname',
  'Map description': 'Regalplanbeschreibung',
  'Left Gap': 'Linke Abstand',
  'Right Gap': 'Rechte Abstand',
  'Top Gap': 'Obere Abstand',
  'Front Gap': 'Vorderer Abstand',
  'Rear Gap': 'Hintere Abstand',
  'Divider Gap': 'Trennungsabstand',
  'Shelf Number': 'Regalnummer',
  'Shelf Name': 'Regalname',
  'Shelf Description': 'Regalbeschreibung',
  'Shelf has been submitted successfully': 'Regal wurde erfolgreich eingereicht',
  'Edit {{name}} Shelf': 'Bearbeiten {{name}} Regal',
  'Add {{name}} Shelf': 'Hinzufügen {{name}} Regal',
  'Assign Shelf': 'Regal zuweisen',
  'Assign Shelf to the map': 'Regale zum Regalplan hinzufügen',
  'Saving...': 'Speichern...',
  'Saving': 'Speichern',
  'Are you sure you want to delete this shelf map? All record related to this shelf map will be deleted as well. This action cannot be undone.': 'Sind Sie sicher, dass Sie diesen Regalplan löschen wollen? Alle zugehörigen Daten werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  'Delete shelf map': 'Regalplan löschen',
  'Created By': 'Erstellt von',
  'Add map': 'Regalplan hinzufügen',
  'Templates': 'Vorlagen',
  'Smart Tag': 'Smart Tag',
  'Template': 'Vorlage',
  'Edit Smart Tag': 'Smart Tag bearbeiten',
  'Edit Template': 'Vorlage bearbeiten',
  'Add Smart Tag': 'Smart Tag hinzufügen',
  'Add Template': 'Vorlage hinzufügen',
  'Create New Smart Tag': 'Neues Smart Tag erstellen',
  'Mac Address': 'MAC Adresse',
  'IP Address': 'IP Adresse',
  'Tag successfully added': 'Smart Tag erfolgreich hinzugefügt',
  'Template Code': 'Vorlagen Code',
  'No user found!': 'Kein Benutzer gefunden!',
  'Invalid email': 'Ungültige E-Mail',
  'User successfully updated': 'Benutzer erfolgreich aktualisiert',
  'User has not updated': 'Benutzer wurde nicht aktualisiert',
  'Basic info, like your name and address that will displayed in public': 'Grundlegende Informationen, wie Ihren Namen und Ihre Adresse, die in der Publikum angezeigt werden',
  'General': 'Allgemein',
  'User Name': 'Benutzername',
  'Updating...': 'Aktualisieren...',
  'RFID/Smart card code': 'RFID/Smart card code',
  'User successfully created': 'Benutzer erfolgreich erstellt',
  'User has not created': 'Benutzer wurde nicht erstellt',
  'User successfully deleted': 'Benutzer erfolgreich gelöscht',
  'User has not deleted': 'Benutzer wurde nicht gelöscht',
  'User successfully enabled': 'Benutzer erfolgreich aktiviert',
  'User has not enabled': 'Benutzer wurde nicht aktiviert',
  'User successfully disabled': 'Benutzer erfolgreich deaktiviert',
  'User has not disabled': 'Benutzer wurde nicht deaktiviert',
  'Password Required': 'Passwort erforderlich',
  'Enter your new password': 'Geben Sie Ihr neues Passwort ein',
  'Only Letters & Numbers Allowed': 'Nur Buchstaben und Zahlen sind erlaubt',
  'Password not match': 'Passwort nicht gleich',
  'Enter your current & new password to reset your password': 'Geben Sie Ihr aktuelles & neues Passwort ein, um Ihr Passwort zu resettieren',
  'Current Password': 'Aktuelles Passwort',
  'New Password': 'Neues Passwort',
  'Password has not updated': 'Passwort wurde nicht aktualisiert',
  'Account': 'Konto',
  'UserName': 'Benutzername',
  'Successfuly Deleted': 'Erfolgreich gelöscht',
  'Product successfuly deleted': 'Produkt erfolgreich gelöscht',
  'Add UOM': 'Einheit hinzufügen',
  'Edit UOM': 'Einheit bearbeiten',
  'Create New UOM': 'Neue Einheit erstellen',
  'Are you sure you want to delete this UOM? All record related to this UOM will be deleted as well. This action cannot be undone.': 'Sind Sie sicher, dass Sie diese Einheit löschen wollen? Alle zugehörigen Daten werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  'Delete UOM': 'Einheit löschen',
  'UOM successfully deleted': 'Einheit erfolgreich gelöscht',
  'UOM has not deleted': 'Einheit wurde nicht gelöscht',
  'UOM successfully added': 'Einheit erfolgreich hinzugefügt',
  'Do you want to delete "{{zone}}"?': 'Wollen Sie "{{zone}}" löschen?',
  'Do you want to delete "{{warehouse}}"?': 'Wollen Sie "{{warehouse}}" löschen?',
  'Warehouse & Zones': 'Lager & Zonen',
  'Warehouse successfully updated': 'Lager erfolgreich aktualisiert',
  'Zone successfully updated': 'Zone erfolgreich aktualisiert',
  'Zone successfully added': 'Zone erfolgreich hinzugefügt',
  'Edit Warehouse': 'Lager bearbeiten',
  'Edit Zone': 'Zone bearbeiten',
  'Create New Warehouse': 'Neues Lager erstellen',
  'Create New Zone': 'Neue Zone erstellen',
  'Zone successfully deleted': 'Zone erfolgreich gelöscht',
  'Warehouse successfully deleted': 'Lager erfolgreich gelöscht',
  'Warehouse has not deleted': 'Lager wurde nicht gelöscht',
  'Zone has not deleted': 'Zone wurde nicht gelöscht',

  'Add to Next Batch': 'Zu dem nächsten Batch hinzufügen',
  'Add Article': 'Artikel hinzufügen',
  'Fixed Location': 'Lagerplatz fixiert',
  'Total Quantity': 'Gesamtmenge',
  'S-C': 'Tablar-Fach',
  'Blocked': 'Gesperrt',
  'PTL RACK NAME': 'PTL REGAL NAME',
  'Bin Types': 'Regal-Typen',
}
